import { render, staticRenderFns } from "./BasicDropdown.vue?vue&type=template&id=6890ec2a&scoped=true"
import script from "./BasicDropdown.vue?vue&type=script&lang=js"
export * from "./BasicDropdown.vue?vue&type=script&lang=js"
import style0 from "./BasicDropdown.vue?vue&type=style&index=0&id=6890ec2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6890ec2a",
  null
  
)

export default component.exports